import type { Product, PropertyGroupOption } from "@shopware-pwa/types";

export const PRODUCT_DETAILS_ASSOCIATIONS = {
  withCmsAssociations: true,
  criteria: {
    associations: {
      manufacturer: {},
      options: { associations: { group: {} } },
      solidPvEmbeddedVideoMedia: {},
      categories: {},
      crossSellings: {},
    },
    includes: {
      product: [
        "name",
        "id",
        "parentId",
        "referencedId",
        "optionIds",
        "calculatedPrice",
        "manufacturer",
        "translated",
        "available",
        "media",
        "solidPvEmbeddedVideoMedia",
        "productNumber",
        "calculatedMaxPurchase",
        "customFields",
        "group",
        "options",
        "crossSellings",
        "categories",
        "subscription",
        "seoUrls",
        "unit",
        "packagingUnit",
        "deliveryTime",
        "maxPurchase",
        "minPurchase",
        "markAsTopseller",
        "isNew",
        "isPreOrderProduct",
        "eshopSetId",
        "packUnit",
        "purchaseUnit",
        "tauschbox",
        "preOrderData",
        "description",
        "metaDescription",
        "metaTitle",
        "packUnitPlural",
      ],
      unit: ["shortCode", "name"],
      media: ["url", "alt", "title", "thumbnails", "customFields"],
    },
  },
};

export const PRODUCT_HERO_ASSOCIATIONS = {
  associations: {
    manufacturer: {},
    options: { associations: { group: {} } },
    categories: {},
    seoUrls: {},
    media: {},
    cover: {},
  },
  includes: {
    product: [
      "available",
      "id",
      "parentId",
      "referencedId",
      "name",
      "price",
      "cover",
      "unit",
      "calculatedPrice",
      "seoUrls",
      "packUnit",
      "purchaseUnit",
      "options",
      "optionIds",
      "translated",
      "groups",
      "packagingUnit",
      "maxPurchase",
      "minPurchase",
      "eshopSetId",
      "manufacturer",
      "categories",
      "media",
      "customFields",
    ],
    unit: ["shortCode", "name"],
  },
};

export const PRODUCT_CARD_ASSOCIATIONS = {
  criteria: {
    associations: {
      manufacturer: {},
      options: { associations: { group: {} } },
      categories: {},
    },
    includes: {
      product: [
        "available",
        "id",
        "parentId",
        "referencedId",
        "name",
        "price",
        "cover",
        "unit",
        "calculatedPrice",
        "seoUrls",
        "packUnit",
        "purchaseUnit",
        "options",
        "optionIds",
        "translated",
        "groups",
        "packagingUnit",
        "maxPurchase",
        "minPurchase",
        "markAsTopseller",
        "isNew",
        "eshopSetId",
        "manufacturer",
        "categories",
      ],
      media: ["url", "alt", "title", "thumbnails"],
      unit: ["shortCode", "name"],
    },
  },
};

export const getFirstColorOption = (product: Product) =>
  ((product?.options as PropertyGroupOption[]) ?? []).find(
    (option) => option.group.displayType === "color",
  );

export const getFirstTextOption = (product?: Product) => {
  return ((product?.options as PropertyGroupOption[]) ?? []).find((option) => {
    return option?.group?.displayType === "text";
  });
};

export const hasFirstOption = (product: Product) => {
  return (getFirstTextOption(product) || getFirstColorOption(product)) ?? false;
};
